<template>
  <div class="container" id="t1content">
    <a-layout-content>
      <T1Breadcrumbs class="mb-16" :homeLink="true" :items="getBreadcrumbs()" />

      <T1RezerwacjaError />
    </a-layout-content>
  </div>
</template>

<script>
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";
import T1RezerwacjaError from "./T1RezerwacjaError";

export default {
  name: "t1content",
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({ name: "Potwierdzenie rezerwacji", link: "" });
      return crumbsArr;
    }
  },
  components: {
    T1Breadcrumbs,
    T1RezerwacjaError
  }
};
</script>
